import Vue from 'vue'
import Router from 'vue-router'
import Consulta from './components/Consulta.vue'
import ConsultaV2 from './components/ConsultaV2.vue'
import Login from './components/Login.vue'
import Landing from './components/Landing.vue'
import LandingV2 from './components/LandingV2.vue'
import OpcioA from './components/OpcioA.vue'
import OpcioB from './components/OpcioB.vue'
import Historia from './components/Historia.vue'
import TermsConditions from './components/TermsConditions.vue'

Vue.use(Router)

export default new Router({
    base: process.env.BASE_URL,
    scrollBehavior(to, from, savedPosition) {
        console.info(to)
        if(to.path != '/') {
            return { x: 0, y: 0 }
        }
    },
    routes: [
        {
            path: '/old',
            name: 'Landing',
            component: Landing
        },
        {
            path: '/',
            name: 'LandingV2',
            component: LandingV2
        },
        {
            path: '/opcio-a',
            name: 'OpcioA',
            component: OpcioA
        },
        {
            path: '/opcio-b',
            name: 'OpcioB',
            component: OpcioB
        },
        {
            path: '/historia',
            name: 'Historia',
            component: Historia
        },
        {
            path: '/consulta',
            name: 'consulta',
            component: Consulta,
            // beforeEnter: (to, from, next) => {
            //     // Vue.$cookies.remove('member_number')
            //     // Vue.$cookies.remove('username')
            //     // next('/')
            //     next()
            // }
        },
        {
            path: '/consulta-v2',
            name: 'consulta-v2',
            component: ConsultaV2,
            // beforeEnter: (to, from, next) => {
            //     // Vue.$cookies.remove('member_number')
            //     // Vue.$cookies.remove('username')
            //     // next('/')
            //     next()
            // }
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
            // beforeEnter: (to, from, next) => {
            //     // Vue.$cookies.remove('member_number')
            //     // Vue.$cookies.remove('username')
            //     next('/consulta')
            // }
        },
        {
            path: '/termes-condicions',
            name: 'terms',
            component: TermsConditions
        },
        {
            path: '/logout',
            name: 'logout',
            beforeEnter: (to, from, next) => {
                Vue.$cookies.remove('member_number')
                Vue.$cookies.remove('username')
                next('/')
            }
        },

    ]
})